<template>
<div class="chapter">
<div class="inner_page">
<p class="ded"><a id="page_vii">for ro stimo</a></p><a id="page_vii">
</a><p class="ded1"><a id="page_vii">finder of clues, solver of mysteries, champion of writers</a><a id="page_viii"></a></p><a id="page_viii">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?474c96de